module.exports = __webpack_public_path__ + "static/img/kl.5551253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/partners/kl.png
// module id = AHEj
// module chunks = 3